const model = {
    total: null,
    orders: [],
    earnings: [],
    loading: false,
    error: null,
};

export default model;